// extracted by mini-css-extract-plugin
export default {"container":"Uba-z","oos":"Vba-z","oosUx":"Wba-z","selected":"Xba-z","labelOos":"Yba-z"};